import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IFlightType } from 'src/models/flight-type.model';
import services from 'src/services/flight-type.service';

export const actionTypes = {
  FLIGHT_TYPE_FETCH: 'FLIGHT_TYPE_FETCH',
  FLIGHT_TYPE_ADD: 'FLIGHT_TYPE_ADD',
  FLIGHT_TYPE_UPDATE: 'FLIGHT_TYPE_UPDATE',
  FLIGHT_TYPE_DELETE: 'FLIGHT_TYPE_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.FLIGHT_TYPE_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.FLIGHT_TYPE_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.FLIGHT_TYPE_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.FLIGHT_TYPE_DELETE,
    service: services.itemDELETE,
  },
};

export type IFlightTypeAsync = typeof asyncActions;

export interface IFlightTypeState extends ICommonState<IFlightTypeAsync> {
  data?: IFlightType;
  list: IFlightType[];
  total: number;
}

export const defaultState: IFlightTypeState = {
  status: {},
  list: [],
  total: 0,
};

const FlightTypeReducer = (
  state: IFlightTypeState = defaultState,
  action: IReducerAction<IFlightTypeAsync>
): IFlightTypeState => {
  switch (action.type) {
    case actionTypes.FLIGHT_TYPE_FETCH: {
      return {
        ...state,
        list: action.payload?.flightType.rows ?? [],
        total: action.payload?.flightType.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default FlightTypeReducer;
